import { css } from '@emotion/css';
import { Color, Font } from 'src/styles';

export const description = css`
  ${Font.lg}
  color: ${Color.Gray8};
`;

export const descriptionSubtitle = css`
  ${Font.md}
  color: ${Color.Gray6};
`;
